/* eslint-disable react/jsx-key */
import React, { Component } from 'react'
import {
  Button,
  Col,
  FormControl,
  FormGroup,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap'
import { DateTimePicker } from 'react-widgets'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { initRoomPrices } from '../redux/actions'
import moment from 'moment'
import { Icon } from 'react-fa'
import $ from 'jquery'
import { getBookableDates } from '../logic/bookableDatesLogic'
import {
  changeSearchParam,
  checkInDateSelector,
  checkOutDateSelector,
  isProgramBookingSelector,
  programDetailsSelector,
  programSelector,
  roomSearchParamsSelector
} from '../redux/modules/searchParamsModule'
import { BSP, FMF_FM, FMF_M, ILM, SAMYAMA } from '../constants/programConstants'
import { isAuthenticatedSelector } from '../redux/selectors/authSelector'
import { getDisplayDate } from '../utils/dateUtils'
import { roomSearchClick } from '../redux/actions/searchActions'
import { populateFormErrors } from '../redux/modules/errorDialogModule'
import { TermsAndConditions } from './searchBar/termsAndConditions'

@autobind
class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showTermsDialog: false,
      isMeditatorChecked: false,
      isVaccineChecked: false
    }
  }

  componentWillMount() {
    if (!this.props.roomPrices || this.props.roomPrices.length === 0) {
      this.props.initRoomPrices()
    }
  }

  componentDidMount() {
    if (!this.props.isAuthenticated) {
      // for the guest user to disable the editing of the input field date time field
      $(document).ready(function() {
        $('.booking-search-widget :input[type="text"]').prop('disabled', true)
      })
    } else {
      // for the logged in user to enable/allow the user to edit the input date time field
      $('.booking-search-widget :input[type="text"]').removeAttr('disabled')
    }
  }

  componentDidUpdate() {
    this.updateEditInputAccess()
  }

  updateEditInputAccess() {
    let {
      auth: { authenticated }
    } = this.props
    if (!authenticated) {
      $('.booking-search-widget :input[type="text"]').prop('disabled', true)
    }
  }

  handleSearchClick() {
    if (
      this.props.program === FMF_M &&
      !this.props.isAuthenticated &&
      !this.state.isMeditatorChecked &&
      this.props.showDetailsText
    ) {
      this.props.populateFormErrors({
        messages: [
          'To book accommodation for this program, ' +
            'you need to have taken the Inner Engineering program, ' +
            'including initiation into Shambhavi Mahamudra Kriya'
        ],
        popupError: true
      })

      return
    }

    if (
      this.props.program === ILM &&
      !this.props.isAuthenticated &&
      !this.state.isVaccineChecked &&
      this.props.showDetailsText
    ) {
      this.props.populateFormErrors({
        messages: [
          'To book accommodation for this program, ' +
            'please confirm by checking the box that you are fully vaccinated ' +
            'and will take a COVID test prior to arrival.'
        ],
        popupError: true
      })

      return
    }

    this.props
      .roomSearchClick()
      .then(() => this.props.searchCB && this.props.searchCB())
  }

  // handle start date separately to add validation for start date.
  handleStartDate(value) {
    let {
      searchParams: { checkOutDate }
    } = this.props
    this.handleChange('checkInDate', value)
    if (moment(checkOutDate) <= moment(value)) {
      // based on start date, re-cal end date and update in date-picker
      this.handleEndDate(
        moment(value)
          .startOf('hour')
          .add(1, 'day')
          .hour(12)
          .toDate()
      )
    }
  }

  // handle end date separately to add validation for end date.
  handleEndDate(value) {
    this.handleChange('checkOutDate', value)
  }

  handleChange(field, value) {
    this.props.changeSearchParam({
      name: field,
      value
    })
  }

  updateAcceptedTC(event) {
    this.handleChange('acceptedTC', event.target.checked)
  }

  openTermsDialog() {
    this.setState({ showTermsDialog: true })
  }

  closeTermsDialog() {
    this.setState({ showTermsDialog: false })
  }

  render() {
    const {
      searchParams: { checkInDate, checkOutDate, acceptedTC },
      auth: { authenticated },
      isProgramBooking,
      program,
      programDates,
      showDetailsText
    } = this.props

    const {
      checkInMinDate,
      checkInMaxDate,
      checkOutMinDate,
      checkOutMaxDate
    } = getBookableDates({
      isAuthenticated: authenticated,
      isProgramBooking,
      program
    })

    const datePickerAttrs = {
      defaultValue: null,
      style: { width: '100%' }
    }
    let termsConditions

    if (authenticated) {
      datePickerAttrs.time = true
      termsConditions = null
    } else {
      termsConditions = (
        <TermsAndConditions
          acceptedTC={acceptedTC}
          program={program}
          showDetailsText={showDetailsText}
          onOpenDialog={this.openTermsDialog}
          onCloseDialog={this.closeTermsDialog}
          showDialog={this.state.showTermsDialog}
          setAcceptedTC={this.updateAcceptedTC}
          isMeditatorChecked={this.state.isMeditatorChecked}
          setIsMeditatorChecked={value =>
            this.setState({ isMeditatorChecked: value })
          }
          isVaccineChecked={this.state.isVaccineChecked}
          setIsVaccineChecked={value =>
            this.setState({ isVaccineChecked: value })
          }
        />
      )
    }

    if (program === SAMYAMA) {
      return (
        <form
          className='booking-search-widget'
          style={{
            padding: '32px 24px',
            maxWidth: '500px',
            margin: '0 auto',
            fontSize: '16px'
          }}
        >
          Additional stay booking is closed. Overnight stay on April 26th is
          included, if you wish to arrive one day early. For additional support
          please submit a ticket through{' '}
          <a
            href='https://support.ishafoundation.org/'
            className={'terms-conditions-link'}
          >
            support.ishafoundation.org
          </a>
          .
        </form>
      )
    }

    return (
      <form className='booking-search-widget'>
        <Row>
          <Col md={2} mdOffset={1} style={{ align: 'center' }}>
            <div className='mobile-header'>
              <FormGroup>
                <FormControl.Static>{<strong>From</strong>}</FormControl.Static>
              </FormGroup>
            </div>
          </Col>
          <Col md={3} className={authenticated ? '' : 'guest-user'}>
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id='checkInDateTooltip'>Check in date</Tooltip>}
            >
              <DateTimePicker
                {...datePickerAttrs}
                value={getDisplayDate(checkInDate)}
                placeholder='Check in date'
                onChange={value => this.handleStartDate(value)}
                min={checkInMinDate}
                max={checkInMaxDate}
              />
            </OverlayTrigger>
          </Col>
          <Col md={1} className='to-text'>
            <p>To</p>
          </Col>
          <Col md={3} className={authenticated ? '' : 'guest-user'}>
            <OverlayTrigger
              placement='top'
              overlay={
                <Tooltip id='checkOutDateTooltip'>Check out date</Tooltip>
              }
            >
              <DateTimePicker
                {...datePickerAttrs}
                value={getDisplayDate(checkOutDate)}
                placeholder='Check out date'
                onChange={value => this.handleEndDate(value)}
                min={checkOutMinDate}
                max={checkOutMaxDate}
              />
            </OverlayTrigger>
          </Col>

          <Col md={2}>
            <div className='search-button'>
              <Button
                data-test-id='btn-search-dates'
                bsStyle='primary'
                onClick={this.handleSearchClick}
              >
                <Icon size='lg' name='search' /> Search
              </Button>
            </div>
          </Col>
        </Row>

        {termsConditions}
        {!authenticated && showDetailsText ? (
          <Row style={{ marginTop: '1rem' }}>
            <Col xs={12} md={7} mdPush={3} style={{ textAlign: 'left' }}>
              <p>
                <strong>Meditate in Adiyogi: The Abode of Yoga</strong>
              </p>

              <p>
                Adiyogi: The Abode of Yoga is your touchstone with the sublime.
                At a moment&rsquo;s notice, you can step away from the fray.
                Take a day, or two, a weekend, or more to bask in the meditative
                bliss of the rare and powerful consecrated space at Isha
                Institute.
                <br />
                <br />
                Allow the stillness to permeate your inner being and instill
                silence within. The day begins with{' '}
                <strong>Guru Pooja available at 5:30 am</strong> in the{' '}
                <strong>
                  lower level of the Abode, followed by yogic sadhana (daily
                  practice)
                </strong>{' '}
                in the elevated energies of the space.
              </p>
              <p>
                Throughout the day, participate in classical yoga and guided
                meditation sessions, hike mountain trails to breathtaking bluffs
                and springfed waterfalls, and enjoy a wholesome homemade
                vegetarian buffet twice a day.
                <br />
                <br />
                As night falls, a special{' '}
                <strong>9:00 to 10:00 pm window</strong> offers{' '}
                <strong>exclusive access to the Abode</strong>, inviting you
                into a quiet hour to simply sit, soak, and become still.
              </p>
              <p>
                To ease your journey,{' '}
                <strong>
                  complimentary shuttle service is provided from Nashville
                  Airport to the Isha Institute
                </strong>
                . Please <strong>arrive before 8:00 PM</strong>, as check-in
                will not be available after the Welcome Center closes.
              </p>
              <p>
                The Isha Institute is a{' '}
                <strong>smoke-free, alcohol-free, and drug-free space</strong>,
                carefully maintained to support a focused and distraction-free
                environment.&nbsp;
              </p>
              <p>
                This is an offering&mdash;not just of time and place, but of
                possibility. We welcome you to come, be still, and allow
                something deeper to unfold within.
              </p>
            </Col>
          </Row>
        ) : null}
      </form>
    )
  }
}

function selectProps(state) {
  return {
    searchParams: roomSearchParamsSelector(state),
    isAuthenticated: isAuthenticatedSelector(state),
    auth: state.common.authentication,
    roomPrices: state.common.roomPrices,
    history: state.common.history,
    isProgramBooking: isProgramBookingSelector(state),
    program: programSelector(state),
    programDates: programDetailsSelector(state).programDates,
    checkInDate: checkInDateSelector(state),
    checkOutDate: checkOutDateSelector(state)
  }
}

const mapDispatchToProps = {
  roomSearchClick,
  initRoomPrices,
  changeSearchParam,
  populateFormErrors
}

export default connect(
  selectProps,
  mapDispatchToProps
)(SearchBar)



// WEBPACK FOOTER //
// ./src/components/searchBar.js